import React from 'react';
import { Box, Container, Typography, Card, CardContent, Divider, Stack, Alert } from '@mui/material';
import { CurrencyRupee, ErrorOutline, CheckCircleOutline, Restore } from '@mui/icons-material';
import PublicNavbar from '../components/common/PublicNavbar';
import PublicFooter from '../components/common/PublicFooter';

export default function RefundPolicyPage() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#060d17', color: '#f8fafc' }}>
      <PublicNavbar />

      <Box sx={{ py: { xs: 6, md: 10 } }}>
        <Container maxWidth="md">
          {/* Header */}
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: '16px',
                bgcolor: 'rgba(239, 68, 68, 0.15)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                mx: 'auto',
                mb: 2,
              }}
            >
              <CurrencyRupee sx={{ color: '#f87171', fontSize: 32 }} />
            </Box>
            <Typography variant="h3" sx={{ fontWeight: 800, mb: 1 }}>
              Refund & Cancellation Policy
            </Typography>
            <Typography variant="body2" sx={{ color: '#94a3b8' }}>
              Effective Date: January 1, 2026 • Version 1.0
            </Typography>
          </Box>

          <Alert
            severity="info"
            icon={<ErrorOutline sx={{ color: '#60a5fa' }} />}
            sx={{
              mb: 5,
              bgcolor: 'rgba(37, 99, 235, 0.08)',
              border: '1px solid rgba(37, 99, 235, 0.3)',
              color: '#dbeafe',
              borderRadius: 3,
              '& .MuiAlert-message': { fontSize: '0.88rem', lineHeight: 1.6 },
            }}
          >
            Please review our refund and cancellation terms carefully before subscribing. By completing a payment of ₹1,000, you acknowledge and accept these terms in full.
          </Alert>

          <Card
            sx={{
              bgcolor: 'rgba(15, 23, 42, 0.7)',
              border: '1px solid rgba(255, 255, 255, 0.08)',
              borderRadius: 4,
              p: { xs: 2, sm: 4 },
              lineHeight: 1.8,
            }}
          >
            <CardContent>
              <Stack spacing={4}>
                {/* 1. Digital Content & Immediate Delivery */}
                <Box>
                  <Typography variant="h6" sx={{ color: '#ffffff', fontWeight: 700, mb: 1 }}>
                    1. Digital Nature of Service & Immediate Delivery
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#cbd5e1' }}>
                    AlphaTrading Alerts is a digital information service. Upon completing the ₹1,000 payment, you receive immediate, automated access to our proprietary Telegram trading notification bot, algorithmic signal feed, and technical research updates.
                  </Typography>
                </Box>

                <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.08)' }} />

                {/* 2. Non-Refundable Policy */}
                <Box>
                  <Typography variant="h6" sx={{ color: '#ffffff', fontWeight: 700, mb: 1 }}>
                    2. Strict No-Refund Policy
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#cbd5e1' }}>
                    Due to the immediate consumption and confidential intellectual nature of real-time trading notifications, <strong>all subscription sales of ₹1,000 / month are final and strictly non-refundable</strong>.
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#cbd5e1', mt: 1 }}>
                    We do not provide prorated refunds or credits for any partial months, unused notification periods, or instances where a subscriber chooses not to trade on the alerts received.
                  </Typography>
                </Box>

                <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.08)' }} />

                {/* 3. Market Outcomes & Performance */}
                <Box>
                  <Typography variant="h6" sx={{ color: '#ffffff', fontWeight: 700, mb: 1 }}>
                    3. No Refunds for Trading Losses
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#cbd5e1' }}>
                    As clearly noted throughout our website, trading in equities and derivatives involves market risks. Refunds will not be granted based on trading results, market volatility, stopped-out trades, or user dissatisfaction with market conditions.
                  </Typography>
                </Box>

                <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.08)' }} />

                {/* 4. Cancellation & Expiry */}
                <Box>
                  <Typography variant="h6" sx={{ color: '#ffffff', fontWeight: 700, mb: 1 }}>
                    4. Cancellation & Expiry
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#cbd5e1' }}>
                    Each ₹1,000 payment covers a 30-day active subscription period. You are under no obligation to renew. If you do not wish to continue after 30 days, simply do not renew, and your bot alerts will automatically cease at the end of your billing cycle without any penalty.
                  </Typography>
                </Box>

                <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.08)' }} />

                {/* 5. Duplicate Payment Inquiries */}
                <Box>
                  <Typography variant="h6" sx={{ color: '#ffffff', fontWeight: 700, mb: 1 }}>
                    5. Duplicate Payment Inquiries
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#cbd5e1' }}>
                    In the rare event that your account is charged more than once for a single billing cycle due to a technical error with the payment gateway or bank, please contact us immediately with both transaction references. Confirmed duplicate charges will be refunded back to the original payment source within 5 to 7 business days.
                  </Typography>
                </Box>
              </Stack>
            </CardContent>
          </Card>
        </Container>
      </Box>

      <PublicFooter />
    </Box>
  );
}
